// 设备布设方式
export const HORIZONTAL = 'horizontal';
export const VERTICAL = 'vertical';
export const CIRCULAR = 'circular';
export const HORIZONTAL_MODE = 0;
export const VERTICAL_MODE = 1;
export const CIRCULAR_MODE = 2;
export const PAGE_SIZE = 20;

// 设备类型
export const ADM = 'CX';
export const SDM = 'DD';
export const SDMX = 'ZD';
export const SDMPRO = 'SDMPRO';
export const SY = 'SY';
export const WL = 'WL';
export const HDA2 = 'SY';
export const HDA3 = 'WL';
export const HDA4 = 'HDA4';
export const HDA5 = 'HDA5';
export const HDA6 = 'HDA6';
export const HDA7 = 'HDA7';
export const HDA8 = 'HDA8';

// 通信模块
export const COM = 'COM';
export const DTU = 'DTU';
export const LORA = 'LORA';
export const MESH = 'MESH';
export const NB = 'NB';
export const CMCC_NB = 'CMCC_NB';

export const SYSTEM_INSERT = 'SYSTEM_INSERT';
export const MANUAL_INSERT = 'MANUAL_INSERT';

// 渗压计算方式，频模计算
export const SY_FORMULA_1 = 'SY_FORMULA_1';
export const SY_FORMULA_2 = 'SY_FORMULA_2';
export const SY_FORMULA_3 = 'SY_FORMULA_3';
export const SY_FORMULA_4 = 'SY_FORMULA_4';
// 渗压计结果值类型，水位高程
export const SY_RESULT_1 = 'SY_RESULT_1';
// 渗压计结果值类型，管口液位
export const SY_RESULT_2 = 'SY_RESULT_2';
